module.exports = {"workerPath":"/serviceWorker.8262538b.js"};